export const switchPagesKey = `csm_switch_topic`;
